import React from "react";
import { ButtonS, ButtonExternalLink } from "../ButtonElement";
import { BtnWrap, Column1, Column2, Heading, Img, ImgWrap, InfoContainer, InfoRow, InfoWrapper, Subtitle, TextWrapper, TopLine } from "./infoElements";

const InfoSection = ({ lightBg, id, imgStart, topLine, lightText, headLine, description, buttonLabel, darkText, alt, im, primary, dark, toR }) => {
  return (
    <>
      <InfoContainer lightBg={lightBg} id={id}>
        <InfoWrapper>
          <InfoRow imgStart={imgStart}>
            <Column1>
              <TextWrapper>
                <TopLine>{topLine}</TopLine>
                <Heading lightText={lightText}>{headLine}</Heading>
                <Subtitle darkText={darkText}>{description}</Subtitle>
                <BtnWrap>
                  {/* <ButtonL to={toR} primary={primary} dark={dark}>
                    {buttonLabel}
                  </ButtonL> */}
                  {
                    toR ? (
                      <ButtonS
                        primary={primary}
                        big="true"
                        dark={dark}
                        to={toR}
                        smooth={true}
                        duration={1000}
                        spy={true}
                        exact="true"
                        offset={0}
                      >
                        {buttonLabel}
                      </ButtonS>) : (
                      <ButtonExternalLink
                        primary={primary}
                        big="true"
                        dark={dark}
                        href="https://wa.me/5491172174129"
                      >
                        {buttonLabel}
                      </ButtonExternalLink>
                    )
                  }
                </BtnWrap>
              </TextWrapper>
            </Column1>
            <Column2>
              <ImgWrap>
                <Img src={im} alt={alt} />
              </ImgWrap>
            </Column2>
          </InfoRow>
        </InfoWrapper>
      </InfoContainer>
    </>
  );
};

export default InfoSection;
